const accordionButtons = document.querySelectorAll('.cmp-accordion__button')
accordionButtons.forEach(button => {
  button.addEventListener('click', e => {
    e.preventDefault()
    const nearestButton = e.target.closest('button')
    const clickedID = nearestButton.id
    history.replaceState(null, null, ' ')
    const currentHash = `#${clickedID}`
    const headerHeight = document.querySelector('.cmp-header')?.clientHeight || 0
    const anchorNavigationHeight = document.querySelector('.cmp-anchor-navigation')?.clientHeight || 0
    setTimeout(() => {
      const elementPosition = document.querySelector(currentHash).getBoundingClientRect().top
      const offsetPosition = elementPosition + window.scrollY - (headerHeight + anchorNavigationHeight + 10)
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      })
      setTimeout(() => history.replaceState(null, null, currentHash), 150)
    }, 0)
  })
})
